import { useDispatch, useSelector } from "react-redux"
import {
  useFetchWithBody,
  usePost,
} from "../../api/reactQueryCustomHooks"
import { apiRoute, CHALLAN_TYPE, decryptText, ENUM_ADVSEARCH_PARAM, ENUM_BILL_TYPE, ENUM_CURRENCY_SETTING_VAL, ENUM_ENTRY_TYPE, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, ENUM_PAGEACTION_TYPE, ENUM_TRADEOF_CODE, ENUM_TRADEOF_TYPE, funGetFormatCurrency, GetLoginCredentialDb, getModMandatory, getModValue, linksUrl, SALE_PUR_ENTRY_TYPE, URIEncrypt } from "../../constants/enum"
import {
  ErrorCard,
  LoadingCard,
  MainContainer,
  NextUITable,
} from "../../components"
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  useDisclosure,
} from "@heroui/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faEdit,
  faPlus,
  faPrint,
  faReceipt,
  faTrash,
} from "@fortawesome/free-solid-svg-icons"

import {
  COLUMN_ALIGN_TYPE,
  COLUMN_TYPE,
  FOOTER_TYPE,
  ROW_ACTION_BTN_TYPE,
} from "../../components/NextUITable"
import { useNavigate, useParams } from "react-router-dom"
import { useEffect, useMemo, useState } from "react"
import { calculateTotal, formatCurrency } from "../../Utility/utility"
import { toast } from "react-toastify"
import ConfirmBox from "../../components/ConfirmBox"
import { resetDetailParams, resetReportData, setDetailParams, setInvoiceDetail, setNewEntryMode } from "../../state/invoiceEntrySlice"
import { enum_Report_Type } from "../report/ReportUtility"
import ReportViewer from "../report/ReportViewer"

const InvoiceEntryMaster = () => {
  let disapatch = useDispatch()
  let navigate = useNavigate()
  const { compCode, isMultipleCompany, yearId, CurrencyFormatBy } = useSelector((state) => state.company)
  const { user, token } = useSelector((state) => state.auth)
  const [itemToDelete, setItemToDelete] = useState("")
  const [itemToEdit, setItemToEdit] = useState("")
  const { btype, trdtype, ptype } = useParams()
  const [entryLabel, setEntryLabel] = useState()
  const [selBillType, setSelBillType] = useState()
  const [selTradeOf, setSelTradeOf] = useState()
  const [selPktType, setSelPktType] = useState()
  const [naviCode, setnaviCode] = useState()
  const [selAdvanceFilter, setSelAdvanceFilter] = useState({})
  const [pageApiAdvFilter, setPageApiAdvFilter] = useState({})
  const [isUseMfgNoAsMktno, setIsUseMfgNoAsMktno] = useState(true)
  const [CurrencySetting, setCurrencySetting] = useState("")
  const [pageActionType, setPageActionType] = useState("")

  const {
    isOpen: isOpenReportModel,
    onOpen: onOpenReportModel,
    onOpenChange: onOpenReportModelChange,
  } = useDisclosure()

  useEffect(() => {
    if (isMultipleCompany)
      navigate(linksUrl.dashboard)
    disapatch(resetDetailParams())
    disapatch(resetReportData())
  }, [])

  useEffect(() => {


    const params = [URIEncrypt.Polish, URIEncrypt.Rough, URIEncrypt.Rejection]
    if (!params.includes(String(trdtype))
      || ![URIEncrypt.Sale, URIEncrypt.Purchase].includes(String(btype))
      || ![URIEncrypt.SinglePacket, URIEncrypt.Mix].includes(String(ptype))
    )
      navigate(linksUrl.dashboard.tradingDashboard)

    if (btype && btype != "" && trdtype && trdtype != "" || ptype && ptype != "") {

      let t_trdtype = trdtype.toLowerCase()
      let t_btype = btype.toLowerCase()
      let t_tradeof = ''
      let t_entryLabel = ''
      let t_billtype = ''
      let t_ptype = ''


      if (ptype == URIEncrypt.SinglePacket)
        t_ptype = 'SNG'
      else
        t_ptype = 'MIX'

      if (t_btype == URIEncrypt.Sale.toLowerCase()) {
        t_billtype = 'S'
      }
      else if (t_btype == URIEncrypt.Purchase.toLowerCase()) {
        t_billtype = 'P'
      }
      if (t_trdtype == URIEncrypt.Polish.toLowerCase()) {
        t_tradeof = ENUM_TRADEOF_CODE.Polish
        t_entryLabel = "Polish Diamond "
        setnaviCode(t_billtype == 'S' ? linksUrl.saleEntry.polishDiamond : t_billtype == 'P' ? linksUrl.purchaseEntry.polishDiamond : "")
      }
      else if (t_trdtype == URIEncrypt.Rough.toLowerCase()) {
        t_tradeof = ENUM_TRADEOF_CODE.Rough
        t_entryLabel = "Rough Diamond "
        setnaviCode(t_billtype == 'S' ? linksUrl.saleEntry.roughDiamond : t_billtype == 'P' ? linksUrl.purchaseEntry.roughDiamond : "")
      }
      else if (t_trdtype == URIEncrypt.Rejection.toLowerCase()) {
        t_tradeof = ENUM_TRADEOF_CODE.Rejection
        t_entryLabel = "Rejection Diamond "
        setnaviCode(t_billtype == 'S' ? linksUrl.saleEntry.rejectDiamond : t_billtype == 'P' ? linksUrl.purchaseEntry.rejectDiamond : "")
      }

      setSelTradeOf(t_tradeof)
      setSelBillType(t_billtype)
      setEntryLabel(t_entryLabel)
      setSelPktType(t_ptype)
      funFilterData(t_billtype, t_tradeof, t_ptype, null, null, null, null, null, null, null, null, null, null, null, null, null);
      setPageApiAdvFilter({ CompCode: compCode.join(','), BillType: t_billtype, TradeOf: t_tradeof })
    }


  }, [btype, trdtype, ptype])

  const { isError: isErrorModSet, data: modSetting = [] } = useFetchWithBody({
    url: apiRoute.modSetting.getModSetting,
    queryKey: "fetchModSettingCurrency",
    inputData: {
      mod_name: ENUM_MOD_NAME.GeneralSettings
    }
  })
  useEffect(() => {
    if (modSetting && modSetting.length > 0) {
      const mktSetting = getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.UseMfgNoAsMktNo, modSetting);
      setIsUseMfgNoAsMktno(mktSetting)
      const currSetting = getModValue(ENUM_MOD_PARAMETER.GeneralSetting.CurrencyType, modSetting) ?? ENUM_CURRENCY_SETTING_VAL.RS;
      setCurrencySetting(currSetting)
    }
  }, [modSetting])

  const {
    isError,
    isPending,
    data = [],
    mutate: filterData
  } = usePost({
    url: apiRoute.invoiceEntry.fetch,
    queryKey: "Invoice Data List",

  })

  const funFilterData = (billtype, tradeof, pkttype, scode, qcode, szcode, shcode, lwcode, itemcode, pacid, brid, fromdate, todate, status, fduedate, tduedate) => {
    console.log("hi")
    filterData({
      data: {
        compcode: compCode.join(","),
        billtype: billtype,
        tradeof: tradeof,
        pkttype: pkttype == 'SNG' ? pkttype : '',
        s_code: scode,
        q_code: qcode,
        sh_code: shcode,
        sz_code: szcode,
        lw_code: lwcode,
        item_code: itemcode,
        pac_id: pacid,
        br_id: brid,
        from_date: fromdate,
        to_date: todate,
        status: status,
        fdue_date: fduedate,
        tdue_date: tduedate
      }
    })

  }


  const onSuccessDelete = (data) => {
    setItemToDelete("")

    if (data && data.length > 0) {
      if (data[0].ref == 1) {
        toast.error("Invoice can't be delete as it locked", {
          "position": "top-center",
          "className": "toast-error",
        })
      }
      else {
        toast.success("deleted successfully", {
          position: "top-center"
        })
        funFilterData(selBillType, selTradeOf, selPktType, null, null, null, null, null, null, null, null, null, null, null, null, null);
      }

    }
  }

  const { mutate: FndeleteNote } = usePost(
    {
      url: apiRoute.invoiceEntry.deleteEntry,
      query: "delete-note",
      onSuccessTasks: onSuccessDelete
    }
  )

  let totalAmt = useMemo(
    () => {
      const total = calculateTotal({
        data: data,
        columnName: "Invoice_Amount",
      })
      return CurrencyFormatBy && CurrencyFormatBy != "" ? funGetFormatCurrency(total, CurrencyFormatBy) : total
    },
    [data]
  )
  let totalAmtD = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "Invoice_AmountD",
      }),
    [data]
  )

  const INITIAL_VISIBLE_COLUMNS = [
    "actions",
    "Party_Name",
    "Invoice_Det",
    "Invoice_No",
    "Invoice_Amount",
    "Invoice_AmountD",
    "Invoice_Weight",
    "C_Rate",
    "AvgRateD",
    "AvgRate",
    "Invoice_Date",
    "Due_Date",
    "Account_Name",
    "status",

  ]
  const [initialColumn, setInitialColumn] = useState(INITIAL_VISIBLE_COLUMNS)

  const exportColumns = [
    {
      name: "PARTY NAME",
      uid: "Party_Name",
    },
    {
      name: "Description",
      uid: "Invoice_Det",
    },
    {
      name: "INVOICE NO",
      uid: "Invoice_No",
    },
    {
      name: "AMOUNT",
      uid: "Invoice_Amount",
      type: COLUMN_TYPE.number,
    },
    {
      name: "AMOUNT($)",
      uid: "Invoice_AmountD",
      type: COLUMN_TYPE.number,
    },
    {
      name: "Weight",
      uid: "Invoice_Weight",
      type: COLUMN_TYPE.number,
    },
    {
      name: "Cnv.Rate",
      uid: "C_Rate",
      type: COLUMN_TYPE.number,
    },
    {
      name: "Avg Rate($)",
      uid: "AvgRateD",
      type: COLUMN_TYPE.number
    },
    {
      name: "Avg Rate",
      uid: "AvgRate",
      type: COLUMN_TYPE.number
    },
    {
      name: "DATE",
      uid: "Invoice_Date",
      type: COLUMN_TYPE.date,
    },
    {
      name: "Due DATE",
      uid: "Due_Date",
      type: COLUMN_TYPE.date,
    },
    {
      name: "ACCOUNT",
      uid: "Account_Name",
    },
    {
      name: "STATUS",
      uid: "status"
    }
  ]
  const [exportCols, setExportCols] = useState(exportColumns)
  let downloadDataFooter = {
    Party_Name: "",
    Invoice_Det: "",
    Invoice_No: "",
    Invoice_Amount: "Total: " + totalAmt,
    Invoice_AmountD: "Total: " + totalAmtD,
    Invoice_Weight: "",
    C_Rate:"",
    AvgRateD: "",
    AvgRate: "",
    Invoice_Date: "",
    Due_Date: "",
    Account: "",
    status: ""
  }

  const [exportFooter, setExportFooter] = useState(downloadDataFooter)
  useEffect(() => {
    if (CurrencySetting && CurrencySetting != "") {
      let AmtColumn = []
      if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.RS)
        AmtColumn = ["Invoice_AmountD", "AvgRateD","C_Rate"]
      else if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.Dollar)
        AmtColumn = ["Invoice_Amount", "AvgRate"]
      else {
        setInitialColumn(INITIAL_VISIBLE_COLUMNS)
        setExportFooter(downloadDataFooter)
        setExportCols(exportColumns)
      }

      if (AmtColumn.length > 0) {
        const filterIniCol = initialColumn.filter(ele => ele != AmtColumn)
        const filterExpCol = exportColumns.filter((ele) => ele.uid != AmtColumn)
        //let footerCol = AmtColumn == 'Invoice_AmountD' ? 'Amount$' : 'Amount'
        const filterExpFooter = Object.keys(downloadDataFooter).filter((ele) => !AmtColumn.includes(ele))
        setExportCols(filterExpCol)
        setInitialColumn(filterIniCol)
        setExportFooter(filterExpFooter)

      }
    }
  }, [CurrencySetting])


  const columns = [
    {
      name: "Actions",
      uid: "actions",
      align: COLUMN_ALIGN_TYPE.center,
    },
    {
      name: "PARTY NAME",
      uid: "Party_Name",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.center,
    },
    {
      name: "Description",
      uid: "Invoice_Det",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.left,
      type: COLUMN_TYPE.multiline
    },
    {
      name: "INVOICE NO",
      uid: "Invoice_No",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.center,
    },
    {
      name: "AMOUNT",
      uid: "Invoice_Amount",
      align: COLUMN_ALIGN_TYPE.center,
      type: CurrencyFormatBy && CurrencyFormatBy != "" ? COLUMN_TYPE.formatedCurrency : COLUMN_TYPE.currency,
      sortable: true,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value:formatCurrency(totalAmt),
      },
    },
    {
      name: "AMOUNT($)",
      uid: "Invoice_AmountD",
      align: COLUMN_ALIGN_TYPE.center,
      sortable:true,
      type:COLUMN_TYPE.number,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalAmtD,
      },
    },
    {
      name: "Weight",
      uid: "Invoice_Weight",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
       type:COLUMN_TYPE.number,

    },
    {
      name: "Cnv.Rate",
      uid: "C_Rate",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
      type: COLUMN_TYPE.number,

    },
    {
      name: "Avg Rate($)",
      uid: "AvgRateD",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
      type: COLUMN_TYPE.number,

    },
    {
      name: "Avg Rate",
      uid: "AvgRate",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
      type: COLUMN_TYPE.currency,
    },
    {
      name: "DATE",
      uid: "Invoice_Date",
      type: COLUMN_TYPE.date,
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    },
    {
      name: "DUE DATE",
      uid: "Due_Date",
      type: COLUMN_TYPE.date,
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    },
    {
      name: "ACCOUNT",
      uid: "Account_Name",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    },
    {
      name: "STATUS",
      uid: "status",
      align: COLUMN_ALIGN_TYPE.center,

    },
  ]

  const handleConfirmBox = (data) => {
    if (data) {
      if (itemToDelete != "" && itemToDelete != null && Object.keys(itemToDelete).length > 0) {
        FndeleteNote({
          data: {
            transaction_id: itemToDelete.transaction_id,
            comp_code: itemToDelete.comp_code,
            pkt_type: itemToDelete.pkt_type,
            bill_type: itemToDelete.bill_type,
            trade_of: selTradeOf
            //mkt_lotno:'0'

          }
        })
      }
      else if (itemToEdit != "" && itemToEdit != null && Object.keys(itemToEdit).length > 0) {
        disapatch(setNewEntryMode(false))
        disapatch(setDetailParams(itemToEdit))

        if (selPktType == 'MIX')
          navigate(naviCode + btype + "/" + trdtype + "/" + ptype + linksUrl.mixEntry + linksUrl.invoiceEntry.createInvoiceEntry)
        else
          navigate(naviCode + btype + "/" + trdtype + "/" + ptype + linksUrl.invoiceEntry.createInvoiceEntry)
      }
    }
    else {
      setItemToDelete("")
      setItemToEdit("")
      setPageActionType("")
    }

  }

  const rowActionBtn = [
    {
      icon: <FontAwesomeIcon color="#379906" icon={faEdit} />,
      onClick: (row) => {
        setItemToDelete("")
        setPageActionType(ENUM_PAGEACTION_TYPE.Edit)
        let obj = {
          comp_code: row.CompCode,
          transaction_id: row.TransactionId,
          bill_type: row.Bill_Type,
          trade_of: row.Trade_Of,
          status: row.status

        }
        setItemToEdit(obj)
        // disapatch(setNewEntryMode(false))
        // disapatch(setDetailParams(obj))

        // if (selPktType == 'MIX')
        //   navigate(naviCode + btype + "/" + trdtype + "/" + ptype + linksUrl.mixEntry + linksUrl.invoiceEntry.createInvoiceEntry)
        // else
        //   navigate(naviCode + btype + "/" + trdtype + "/" + ptype + linksUrl.invoiceEntry.createInvoiceEntry)

      },
      type: ROW_ACTION_BTN_TYPE.link,
    },
    {
      icon: <FontAwesomeIcon color="#c40c18" icon={faTrash} />,
      onClick: (row) => {
        if (row.status == "Pending") {
          setItemToEdit("")
          setPageActionType(ENUM_PAGEACTION_TYPE.Delete)
          setItemToDelete({ transaction_id: row.TransactionId, comp_code: row.CompCode, pkt_type: row.PktType, bill_type: row.Bill_Type })
        }
        else {
          toast.error("Invoice can't be delete as it locked", {
            "position": "top-center",
            "className": "toast-error",
          })
        }
      },
      type: ROW_ACTION_BTN_TYPE.link,
    }, {
      icon: selBillType == 'S' ? <FontAwesomeIcon color="#c511b7" icon={faPrint} /> : "",
      onClick: (row) => {
        if (selBillType == 'S') {
          let obj = {
            comp_code: row.CompCode,
            bill_type: row.Bill_Type,
            trade_of: row.Trade_Of,
            trans_id: row.TransactionId,
            token: token,
            db_user: GetLoginCredentialDb(user, yearId)
          }
          // window.open(linksUrl.report, '_blank');
          disapatch(setInvoiceDetail(obj))
          onOpenReportModel()
        }
      },
      type: selBillType == 'S' ? ROW_ACTION_BTN_TYPE.link : "",
    }
  ]

  const reportModel = () => {
    return (
      <div>
        <Modal
          isOpen={isOpenReportModel}
          onOpenChange={onOpenReportModelChange}
          size="3xl"
          placement="center"
          scrollBehavior="inside"
        >
          <ModalContent>
            {(onClose) => (
              <>
                <ModalHeader className="m-0 px-2 bg-gray-100 border-b-2 border-gray-700">
                  {`${selBillType == "S" ? "Sale" : "Purchase "} ${entryLabel}  Invoice  (${selPktType == 'SNG' ? "Single" : "Mix"})`}
                </ModalHeader>
                <ModalBody className="">
                  <div className="h-full">
                    <ReportViewer props_ReportType={enum_Report_Type.INVOICE} />
                  </div>
                </ModalBody>
              </>
            )}
          </ModalContent>
        </Modal>
      </div>
    )
  }
  const handleAddNew = () => {
    disapatch(resetDetailParams())
    if (selPktType == 'MIX')
      navigate(naviCode + btype + "/" + trdtype + "/" + ptype + linksUrl.mixEntry + linksUrl.invoiceEntry.createInvoiceEntry)
    else
      navigate(naviCode + btype + "/" + trdtype + "/" + ptype + linksUrl.invoiceEntry.createInvoiceEntry)

  }
  const ADVFILTER_VISIBLE_FIELD = [
    //...Object.values(ENUM_ADVSEARCH_PARAM)
    ENUM_ADVSEARCH_PARAM.Shape,
    ENUM_ADVSEARCH_PARAM.Purity,
    ENUM_ADVSEARCH_PARAM.Color,
    ENUM_ADVSEARCH_PARAM.Size,
    ENUM_ADVSEARCH_PARAM.Party,
    ENUM_ADVSEARCH_PARAM.Broker,
    ENUM_ADVSEARCH_PARAM.Item,
    ENUM_ADVSEARCH_PARAM.LwRatio,
    ENUM_ADVSEARCH_PARAM.VouFromDate,
    ENUM_ADVSEARCH_PARAM.VouToDate,
    ENUM_ADVSEARCH_PARAM.DueToDate,
    ENUM_ADVSEARCH_PARAM.DueFromDate,
    ENUM_ADVSEARCH_PARAM.Status,
    //ENUM_ADVSEARCH_PARAM.VouNo,
  ]
  const handleFilterChange = (newFilters) => {
    //console.log('Received filters in parent:', newFilters);
    setSelAdvanceFilter(newFilters)
    funFilterData(selBillType, selTradeOf, selPktType,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Shape) ? newFilters[ENUM_ADVSEARCH_PARAM.Shape] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Purity) ? newFilters[ENUM_ADVSEARCH_PARAM.Purity] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Size) ? newFilters[ENUM_ADVSEARCH_PARAM.Size] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Color) ? newFilters[ENUM_ADVSEARCH_PARAM.Color] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.LwRatio) ? newFilters[ENUM_ADVSEARCH_PARAM.LwRatio] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Item) ? newFilters[ENUM_ADVSEARCH_PARAM.Item] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Party) ? newFilters[ENUM_ADVSEARCH_PARAM.Party] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Broker) ? newFilters[ENUM_ADVSEARCH_PARAM.Broker] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.VouFromDate) ? newFilters[ENUM_ADVSEARCH_PARAM.VouFromDate] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.VouToDate) ? newFilters[ENUM_ADVSEARCH_PARAM.VouToDate] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Status) ? newFilters[ENUM_ADVSEARCH_PARAM.Status] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.DueFromDate) ? newFilters[ENUM_ADVSEARCH_PARAM.DueFromDate] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.DueToDate) ? newFilters[ENUM_ADVSEARCH_PARAM.DueToDate] : null,

    )

  };

  if (isError) {
    return <ErrorCard />
  }

  if (isPending) {
    return <LoadingCard />
  }
  return (
    <div>

      {itemToDelete != "" || itemToEdit != "" ? <ConfirmBox handleConfirmBox={handleConfirmBox} actionType={pageActionType} /> : ""}

      <MainContainer
        pageName={entryLabel + `Invoice - ${selPktType == 'SNG' ? "Single Packet" : selPktType}`}
        info={[]}
        breadcrumbs={[selBillType == 'S' ? 'Sale' : 'Purchase', entryLabel, "Invoice", selPktType == 'SNG' ? "Single Packet" : selPktType]}
      >
        {reportModel()}
        <div className="" style={{ textAlign: "right" }}>
          <Button
            size="sm"
            color="primary"
            startContent={<FontAwesomeIcon icon={faPlus} />}
            onPress={handleAddNew}
          >
            Add New
          </Button>
        </div>

        <NextUITable
          INITIAL_VISIBLE_COLUMNS={initialColumn}
          data={data}
          columns={columns}
          rowActionBtn={rowActionBtn}
          exportColumns={exportCols}
          downloadDataFooter={exportFooter}
          downloadFileName={entryLabel + "Invoice-List"}
          onFilterChange={handleFilterChange}
          advanceFilterParam={selAdvanceFilter}
          advFilterPageApiParam={pageApiAdvFilter}
          advFilterVisibleField={ADVFILTER_VISIBLE_FIELD}
          id="TransactionId"
        ></NextUITable>
      </MainContainer>
    </div>
  )
}
export default InvoiceEntryMaster
